export const environment = {
  production: true,
  version: '5.19.0.416'
};
